module.exports = __webpack_public_path__ + "static/media/1029261.cde52dd5.png";